import styled from 'styled-components'
import { device } from '../../theme/breakpoints'

const Container = styled.div`
  width: 100%;
  padding: 0 3rem;
  margin: auto;

  @media ${device.tablet} {
    padding: 0;
    max-width: ${(props) => props.theme.maxWidths.tablet};
    ${(props) =>
      props.maxWidth === 'tablet' &&
      `
      max-width: ${props.theme.maxWidths.tablet} !important;
    `};
  }

  @media ${device.laptop} {
    max-width: ${(props) => props.theme.maxWidths.laptop};

    ${(props) =>
      props.maxWidth === 'laptop' &&
      `
      max-width: ${props.theme.maxWidths.laptop} !important;
    `};
  }

  @media ${device.laptopL} {
    max-width: ${(props) => props.theme.maxWidths.laptopL};

    ${(props) =>
      props.maxWidth === 'laptopL' &&
      `
      max-width: ${props.theme.maxWidths.laptopL} !important;
    `};
  }

  ${(props) =>
    props.center &&
    `
    text-align: center;
  `};
`

export default Container
